<template>
  <div id="content" class="pc">
    <board-menu></board-menu>
    <router-view :key="key"></router-view>
  </div>
</template>

<script>
import BoardMenu from '../../../layout/web/components/BoardMenu'

export default {
  name: 'Contents',
  components: {
    BoardMenu
  },
  computed: {
    key () {
      return this.$route.path
    }
  }
}
</script>

<style scoped>

#content.pc {
  height: 100%;
}

#content.pc #gnb {
  height: calc(100vh - 77px);
  top: 77px;
}

#content{justify-content: flex-end;align-items: flex-end;}
</style>
